export default __webpack_public_path__ + "static/media/card-image.dc08ff83.png";